// necessary set
import React from 'react'
import { observer } from 'mobx-react'

// need content
import BoardTh from '@pages/board/BoardTh'

// need tool or method
// Props type
// Param type
// need style
import './board.scss'
import { BoardList } from './Board'

/**
 * @author cardo
 * @description
 * sto-user-front: NoticeContainer
 * Notice Container
 */
const NoticeContainer: React.FC = observer(() => {
  return (
    <React.Fragment>
      <div className="section-full b-black-bg">
        <div className="section-part" style={{ '--sectionWidth': '1280px' } as React.CSSProperties}>
          <div className="board-door">공지사항</div>
        </div>
      </div>

      <div className="section-part " style={{ '--sectionWidth': '1280px' } as React.CSSProperties}>
        <div className="noti-content">
          <div className="board-tab">
            <span className="active">공지사항</span>
          </div>

          <div className="tb-body">
            <BoardTh
              titleTxt={[
                { text: '구분', width: 10 },
                { text: '제목', width: 70 },
                { text: '게시일', width: 20 },
              ]}
            />
            <BoardList />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})

export default NoticeContainer
